import FeedLayout from "layouts/files/FeedLayout";
import { Link } from "react-router-dom";
import { NotificationItem, SVG } from "ui";

import { usersArray } from "assets/data/usersData";

const NotificationsPage = () => {
    return (
        <FeedLayout pageTitle="Notifications">
            <div className="notifications-page">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Notifications</h1>

                    <div className="svg-circle big-circle">
                        <SVG svg="trash" size={24} />
                    </div>
                </div>
                <div className="card pl-10 pr-10 pt-10 pb-10">
                    {usersArray.map((user) => (
                        <NotificationItem user={user} key={user.id} />
                    ))}
                </div>
            </div>
        </FeedLayout>
    );
};

export default NotificationsPage;
